import { Box } from '@chakra-ui/react';

function DndSpacer() {
  return <Box h="2px" bg="#ffd540" w="100%" />;
}

export default DndSpacer;
